export default {
  CARD: "card"
};
